import { render, staticRenderFns } from "./QuantityVoucherSoldInAgent.vue?vue&type=template&id=4ce6b2d8&scoped=true&"
import script from "./QuantityVoucherSoldInAgent.vue?vue&type=script&lang=js&"
export * from "./QuantityVoucherSoldInAgent.vue?vue&type=script&lang=js&"
import style0 from "./QuantityVoucherSoldInAgent.vue?vue&type=style&index=0&id=4ce6b2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6b2d8",
  null
  
)

export default component.exports